(function () {
  'use strict';

  var TYPE_LABELS = {
    clinical_study: 'Klinik Çalışma',
    case_study: 'Vaka Çalışması',
    safety_doc: 'Güvenlik Belgesi',
    product_doc: 'Ürün Belgesi',
    technical_doc: 'Teknik Doküman'
  };

  var FILTER_GROUPS = {
    clinical_study: 'clinical',
    case_study: 'case',
    safety_doc: 'safety',
    product_doc: 'technical',
    technical_doc: 'technical'
  };

  var FILTER_LABELS = {
    all: 'Tümü',
    clinical: 'Klinik Çalışmalar',
    case: 'Vaka Çalışmaları',
    safety: 'Güvenlik Belgeleri',
    technical: 'Teknik Belgeler'
  };

  function normalize(value) {
    return (value || '')
      .toString()
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function initSection(root) {
    if (!root || root.dataset.nsReady === 'true') return;
    root.dataset.nsReady = 'true';

    var search = root.querySelector('[data-ns-search]');
    var filtersWrap = root.querySelector('[data-ns-filters]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ns-card]'));
    var empty = root.querySelector('[data-ns-empty]');
    var activeFilter = 'all';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function buildFilters() {
      if (!filtersWrap || filtersWrap.dataset.nsBuilt === 'true') return;
      filtersWrap.dataset.nsBuilt = 'true';
      filtersWrap.innerHTML = '';

      var groups = {};
      cards.forEach(function (card) {
        var group = card.getAttribute('data-ns-filter-group') || '';
        if (group) groups[group] = true;
      });

      var order = ['all'];
      ['clinical', 'case', 'safety', 'technical'].forEach(function (key) {
        if (groups[key]) order.push(key);
      });

      order.forEach(function (key) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nogag-studies__filter';
        btn.setAttribute('data-ns-filter', key);
        btn.setAttribute('aria-pressed', key === 'all' ? 'true' : 'false');
        btn.textContent = FILTER_LABELS[key] || key;
        filtersWrap.appendChild(btn);
      });

      filtersWrap.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-ns-filter]');
        if (!btn) return;
        activeFilter = btn.getAttribute('data-ns-filter') || 'all';
        Array.prototype.forEach.call(filtersWrap.querySelectorAll('[data-ns-filter]'), function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        applyFilters();
      });
    }

    function applyFilters() {
      var q = normalize(search ? search.value : '');
      var visible = 0;

      cards.forEach(function (card) {
        var group = card.getAttribute('data-ns-filter-group') || '';
        var haystack = normalize(card.getAttribute('data-ns-search'));
        var filterOk = activeFilter === 'all' || group === activeFilter;
        var searchOk = !q || haystack.indexOf(q) !== -1;
        var show = filterOk && searchOk;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    if (search) search.addEventListener('input', applyFilters);

    if (filtersWrap) buildFilters();
    applyFilters();

    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
      });
      var selected = event.target.closest('[data-ns-card]') || event.target.querySelector('[data-ns-card]');
      if (selected) {
        selected.classList.add('is-selected');
        selected.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    });

    document.addEventListener('shopify:block:deselect', function () {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-nogag-studies]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-nogag-studies]') ||
          (event.target.matches && event.target.matches('[data-nogag-studies]') ? event.target : null)
        : null;
    if (section) {
      section.dataset.nsReady = 'false';
      initSection(section);
    }
  });

  window.NogagStudies = { TYPE_LABELS: TYPE_LABELS, FILTER_GROUPS: FILTER_GROUPS };
})();
